import { render, staticRenderFns } from "./QuotaHistory.vue?vue&type=template&id=13d5aa32"
import script from "./QuotaHistory.vue?vue&type=script&lang=js"
export * from "./QuotaHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports